import { getProspectReference } from "@utils/storage";
import { getEndpoint } from "./endpoint";
import { keycloakUtils } from "itsf-ui-common";

const MS_NAME = "elavon-facade";

export const getIframeAndValidatePaymentAcquisitionApiRoute = () =>
    `${getEndpoint(MS_NAME)}hpp/acquisition-prospects/${getProspectReference()}`;

export const getIframeAndValidatePaymentCrossSellApiRoute = () =>
    `${getEndpoint(MS_NAME)}hpp/cross-sells/${getProspectReference()}`;

export const getIframeAndValidatePaymentApiRoute = () =>
    keycloakUtils.isAuthenticated()
        ? getIframeAndValidatePaymentCrossSellApiRoute()
        : getIframeAndValidatePaymentAcquisitionApiRoute();

export const getPaymentProviderApiRoute = () => `${getEndpoint(MS_NAME)}payments/provider`;
